<template>
<div v-if="show_number_of_subscriptions" class="number-of-subscriptions-info">
  <div class="row mx-0">
    <div v-if="is_manage_subs" class="col-8 pl-0">
      <p class="subscription-name mb-0">{{ recurrable_name }}</p>
    </div>
    <div v-else class="col-8 pl-0">
      <p class="mb-0">
        <span v-if="isMobileXsSm">You have</span>
        {{ number_of_subscriptions }} subscriptions
      </p>
    </div>
    <div class="col-4 pr-0 d-flex justify-content-end">
      <button class="btn sm-txt number-of-subscriptions-info-btn" @click="openModal(isMobileXsSm ? 1 : 0)"> switch </button>
    </div>
    <div v-if="is_manage_subs" class="col-12 px-0">
      <p class="mb-0" style="font-family: 'Apercu'; font-weight: 300;">{{ number_of_subscriptions }} Subscriptions</p>
    </div>
  </div>
</div>
<!-- Switch Subscriptions Modal -->
<DesktopOverlay :is_active="overlay_control_vars[0]" @overlay-click="flipOverlay(0)">
  <template #overlayContent>
    <div class="account-new-header-popup">
      <div class="account-new-header-popup-content row mx-0">
        <div class="col-12 px-0">
          <div class="row mx-0">
            <div class="col-6 px-0">
              <h4 class="account-new-header-popup-title m-sm">
                Switch Subscription
              </h4>
            </div>
            <div class="col-6 px-0">
              <img
                class="ml-auto hand-pointer"
                src="/assets/icons/primary/close_basket.svg"
                width="15"
                height="15"
                alt="close roast popup"
                @click="flipOverlay(0)"
              />
            </div>
          </div>
        </div>
        <div :class="{'col-12 px-1 row mx-0 account-new-header-popup-content-body': true, 'scroller': subscriptions_list.length > 2}">
          <div
            v-for="(subscription, index) in subscriptions_list"
            :key="index"
            :class="{
              'col-6 mb-3 subscription-simple-card hand-pointer': true,
              'left': index % 2 === 0,
              'right': index % 2 !== 0,
              'no-coffee': subscription.recurrable_coffee && subscription.recurrable_coffee.name === null
            }"
            @click="selectSubscription(subscription.id)"
          >
            <div :class="{
                'subscription-simple-card-content': true,
                'is_picked': subscription.id === picked_subscription_id,
                'is-paused': is_paused(subscription),
                'left': index % 2 === 0,
                'right': index % 2 !== 0,
              }">
              <div :class="{'subscription-simple-card-details row mx-0': true, 'no-coffee': subscription.recurrable_coffee && subscription.recurrable_coffee.name === null }">
                <div class="col-1 pl-0 pr-0 pr-lg-2">
                  <img v-if="subscription.id === picked_subscription_id" src="/assets/icons/misc/picked-checkmark-darker.svg" alt="checkmark"/>
                  <img v-else src="/assets/icons/misc/unchecked.svg" alt="checkmark"/>
                </div>
                <div class="col-11 pl-2 pl-lg-0 pr-0 row mx-0">
                  <div class="col-7 px-0">
                    <p class="subscription-simple-card-details-name">{{ subscription.name }}</p>
                  </div>
                  <div v-if="is_paused(subscription)" class="col-5 px-0 d-flex justify-content-end">
                    <div class="paused-banner d-flex align-items-center">
                      <p class="mb-0">Paused</p>
                    </div>
                  </div>
                  <div v-else-if="order_is_being_prepared(subscription)" class="col-5 px-0 d-flex justify-content-end">
                    <div class="being-prepared-banner d-flex align-items-center">
                      <p class="mb-0">Being Prepared</p>
                    </div>
                  </div>
                  <div v-else class="col-5 px-0 t-right" :style="{ 'height': is_pioneer_price_flag(subscription) ? '38px' : '' }">
                    <p class="price mb-0">£{{ recurrable_coffee_price(subscription) }}</p>
                    <p v-if="is_pioneer_price_flag(subscription)" class="original-price mb-0"> was (<span class="price-trace">£{{  recurrable_coffee_original_price(subscription) }}</span>)</p>
                  </div>
                  <div v-if="subscription.recurrable_coffee && subscription.recurrable_coffee.name !== null" class="col-12 px-0">
                    <p class="subscription-simple-card-details-dispatch-date">{{!is_paused(subscription) ? 'Next' : 'Last'}} shipped {{ getMonthName(subscription.next_shipping_date).slice(0, 3) }} {{ getDay(subscription.next_shipping_date, true) }}</p>
                  </div>
                  <div v-if="subscription.recurrable_coffee && subscription.recurrable_coffee.name !== null" class="col-12 px-0">
                    <p class="subscription-simple-card-details-coffee-name">{{ subscription.recurrable_coffee.name }}</p>
                  </div>
                  <div v-if="subscription.recurrable_coffee && subscription.recurrable_coffee.name !== null" class="col-12 px-0">
                    <p class="subscription-simple-card-details-description">
                      {{ subscription_amount(subscription) === 1000 ? '1kg' : is_pods(subscription) ? subscription_amount(subscription) + ' pods' : subscription_amount(subscription) + 'g' }}
                      <div v-if="subscription_method(subscription) !== false" class="d-inline">
                        <span></span>
                        for {{ subscription_method(subscription).replace('_',' ') }}
                      </div>
                    </p>
                  </div>
                </div>
              </div>
              <div class="col-12 row mx-0 subscription-simple-card-address">
                <img class="subscription-simple-card-address-icon" src="assets/icons/gray/free_delivery.svg" width="20" height="14" alt="delivery truck">
                <div class="col-12" style="padding: 0px 20px;">
                  <p class="mb-0" :title="subscription_address(subscription)">[<span>{{subscription_address(subscription).trim()}}</span>]</p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-12 px-0 mt-4">
          <div class="d-inline">
            <button class="btn btn-gray-black-text disable-hover disable-focus disable-active" @click="flipOverlay(0)"> cancel </button>
          </div>
          <div class="d-inline ml-3">
            <button class="btn btn-secondary disable-hover disable-focus disable-active" @click="switchSubscription(0)"> confirm </button>
          </div>
        </div>
      </div>
    </div>
  </template>
</DesktopOverlay>
<MobileOverlayFull :is_active="overlay_control_vars[1]" @overlay-click="flipOverlay(1)">
  <template #overlayContent>
    <div class="account-new-header-popup mob">
      <div class="account-new-header-popup-content row mx-0">
        <div class="col-12 px-0">
          <div class="row mx-0">
            <div class="col-6 px-0">
              <h4 class="account-new-header-popup-title m-sm">
                Switch Subscription
              </h4>
            </div>
            <div class="col-6 px-0">
              <img
                class="ml-auto hand-pointer"
                src="/assets/icons/primary/close_basket.svg"
                width="15"
                height="15"
                alt="close roast popup"
                @click="flipOverlay(1)"
              />
            </div>
          </div>
        </div>
        <div :class="{'col-12 px-1 row mx-0 account-new-header-popup-content-body': true, 'scroller': subscriptions_list.length > 2}">
          <div
            v-for="(subscription, index) in subscriptions_list"
            :key="index"
            class="col-12 px-0 mb-3 subscription-simple-card"
            @click="selectSubscription(subscription.id)"
          >
            <div :class="{'subscription-simple-card-content': true, 'is_picked': subscription.id === picked_subscription_id, 'is-paused': is_paused(subscription) }">
              <div class="subscription-simple-card-details row mx-0">
                <div class="col-1 pl-0 pr-0 pr-lg-2">
                  <img v-if="subscription.id === picked_subscription_id" src="/assets/icons/misc/picked-checkmark-darker.svg" alt="checkmark"/>
                  <img v-else src="/assets/icons/misc/unchecked.svg" alt="checkmark"/>
                </div>
                <div class="col-11 pl-2 pl-lg-0 pr-0 row mx-0">
                  <div class="col-7 px-0">
                    <p class="subscription-simple-card-details-name">{{ subscription.name }}</p>
                  </div>
                  <div v-if="is_paused(subscription)" class="col-5 px-0 d-flex justify-content-end">
                    <div class="paused-banner d-flex align-items-center">
                      <p class="mb-0">Paused</p>
                    </div>
                  </div>
                  <div v-else-if="order_is_being_prepared(subscription)" class="col-5 px-0 d-flex justify-content-end">
                    <div class="being-prepared-banner d-flex align-items-center">
                      <p class="mb-0">Being Prepared</p>
                    </div>
                  </div>
                  <div v-else class="col-5 px-0 t-right">
                    <p class="price mb-0">£{{ recurrable_coffee_price(subscription) }}</p>
                    <p v-if="is_pioneer_price_flag(subscription)" class="original-price mb-0"> was (<span class="price-trace">£{{  recurrable_coffee_original_price(subscription) }}</span>)</p>
                  </div>
                  <div v-if="subscription.recurrable_coffee && subscription.recurrable_coffee.name !== null" class="col-12 px-0">
                    <p class="subscription-simple-card-details-dispatch-date">{{!is_paused(subscription) ? 'Next' : 'Last'}} shipped {{ getMonthName(subscription.next_shipping_date).slice(0, 3) }} {{ getDay(subscription.next_shipping_date, true) }}</p>
                  </div>
                  <div v-if="subscription.recurrable_coffee && subscription.recurrable_coffee.name !== null" class="col-12 px-0">
                    <p class="subscription-simple-card-details-coffee-name">{{ subscription.recurrable_coffee.name }}</p>
                  </div>
                  <div v-if="subscription.recurrable_coffee && subscription.recurrable_coffee.name !== null" class="col-12 px-0">
                    <p class="subscription-simple-card-details-description">
                      {{ subscription_amount(subscription) === 1000 ? '1kg' : is_pods(subscription) ? subscription_amount(subscription) + ' pods' : subscription_amount(subscription) + 'g' }}
                      <div v-if="subscription_method(subscription) !== false" class="d-inline">
                        <span></span>
                        for {{ subscription_method(subscription).replace('_',' ') }}
                      </div>
                    </p>
                  </div>
                </div>
              </div>
              <div class="col-12 row mx-0 subscription-simple-card-address">
                <div class="col-1 px-0 d-flex align-items-center">
                  <img src="assets/icons/gray/free_delivery.svg" width="20" height="14" alt="delivery truck">
                </div>
                <div class="col-11 px-0">
                  <p class="mb-0">[{{subscription_address(subscription)}}]</p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-12 px-0 mt-4">
          <div class="d-inline">
            <button class="btn btn-gray-black-text disable-hover disable-focus disable-active" @click="flipOverlay(1)" style="min-width: 138px;padding: 0 26px;"> cancel </button>
          </div>
          <div class="d-inline ml-3">
            <button class="btn btn-secondary disable-hover disable-focus disable-active" @click="switchSubscription(1)" style="min-width: 138px;padding: 0 26px;"> confirm </button>
          </div>
        </div>
      </div>
    </div>
  </template>
</MobileOverlayFull>
<!-- End Switch Subscriptions Modal -->
</template>

<script setup>
import { defineAsyncComponent, ref, toRefs, computed, watch, onMounted, onBeforeMount } from 'vue'
import { useRoute } from 'vue-router'
import { useAuthUser } from '../../../utils/stores/modules/authUser'
import { useMultipleOverlays } from '../../utils/Overlays/multipleOverlayHelpers'
import { useDateHelpers } from '../../utils/composables/dateHelpers'
import { useMobileHelpers } from '../../utils/composables/mobileHelpers'

const DesktopOverlay = defineAsyncComponent(() => import('../../utils/Overlays/DesktopOverlay.vue'))
const MobileOverlayFull = defineAsyncComponent(() => import('../../utils/Overlays/MobileOverlayFull.vue'))

const route = useRoute()
const userStore = useAuthUser()
// Props (defineProps)
const props = defineProps({
  is_manage_subs: {
    type: Boolean,
    required: false,
    default: false
  }
})
// Emits (defineEmits)
// Reactive variables (inc composables)
const picked_subscription_id = ref(undefined)
const { overlay_control_vars, flipOverlay } = useMultipleOverlays(2)
const { getMonthName, getDay } = useDateHelpers()
const { is_manage_subs } = toRefs(props)
const { isMobileXsSm } = useMobileHelpers()
// Computed
const recurrables_state_count = computed(() => userStore.recurrableStateCount)
const number_of_subscriptions = computed(() => recurrables_state_count.value?.active + recurrables_state_count.value?.paused)
const primary_recurrable = computed(() => userStore.primaryRecurrable)
const recurrable_name = computed(() => primary_recurrable.value && primary_recurrable.value.name)
const condition_to_show_in_header = computed(() => number_of_subscriptions.value > 1 && route.name === 'my subscription')
const show_number_of_subscriptions = computed(() => is_manage_subs.value ? number_of_subscriptions.value > 1 : condition_to_show_in_header.value )
const subscriptions_list = computed(() => userStore.recurrablesSwitchList)
// Methods
function openModal(id) {
  flipOverlay(id)
}
function selectSubscription(id) {
  picked_subscription_id.value = id
}
function switchSubscription(id) {
  userStore.getRecurrablebyId(picked_subscription_id.value)
  flipOverlay(id)
}
function is_pods(subscription){
  return subscription.coffee_plan.coffee_type === 'pod'
}
function is_paused(subscription){
  return subscription.current_state === 'paused'
}
function order_is_being_prepared(subscription) {
  return subscription.order_state === 'billed' || subscription.order_state === 'printed'
}
function is_pioneer_price_flag(subscription) { return subscription.recurrable_coffee.pioner_price }
function recurrable_coffee_price(subscription) { return parseFloat(subscription.recurrable_coffee.price).toFixed(2) }
function recurrable_coffee_original_price(subscription) { return parseFloat(subscription.recurrable_coffee.non_pioneer_price).toFixed(2) }
function subscription_amount(subscription){
  return is_paused(subscription) ? subscription.coffee_plan.amount : subscription.recurrable_coffee.weight
}
function subscription_address(subscription){
  var with_line_2 = subscription.address.address_line_1+' '+subscription.address.address_line_2+', '+subscription.address.city+', '+subscription.address.postcode
  var without_line_2 = subscription.address.address_line_1+', '+subscription.address.city+', '+subscription.address.postcode
  return subscription.address.address_line_2 !== null && subscription.address.address_line_2 !== '' ? with_line_2 : without_line_2
}
function subscription_method(subscription){
  return subscription.brew_method !== null && subscription.brew_method.slice(0, 1).toUpperCase() + subscription.brew_method.slice(1)
}
// Watchers
watch(primary_recurrable, (newV) => {
  if(newV !== undefined && newV !== null)
    picked_subscription_id.value = newV.id
})
// Lifecycle Hooks
onBeforeMount(() => {
  if(number_of_subscriptions.value > 1){
    userStore.getRecurrablesSwitchList()
  }
})
onMounted(() => {
  if(primary_recurrable.value?.id !== undefined || primary_recurrable.value?.id !== null)
    picked_subscription_id.value = primary_recurrable.value?.id
})
// Expose (defineExpose)
</script>
<script>
export default {
	name: 'AccountSubscriptionsList',
}
</script>
<style lang="scss">
@use '../../../../assets/sass/inc/default/grid/grid-vue-mixins.scss' as *;
  .number-of-subscriptions-info{
    p{
      color: #646668;
      /* XS-M */
      font-family: 'Apercu-medium';
      font-size: 16px;
      font-style: normal;
      font-weight: 500;
      line-height: 24px; /* 150% */
      letter-spacing: 0px;

      &.subscription-name{
        color: #212427;
      }
    }

    &-btn{
      background-color: #E9E9E9;
      color: #1D4045;
      min-width: 77px !important;
      max-width: 77px !important;
      height: 26px;
      line-height: 26px;
      letter-spacing: 1px !important;
      padding: 0px 8px;
      border-radius: 4px;
    }
  }

  .account-new-header-popup {
    max-width: 960px;
    min-height: 180px;
    // max-height: 405px;
    margin: 0px auto;
    padding: 32px;
    background-color: #fff;
    transition: all 0.3s ease;

    @include target-md{
      max-width: 720px;
    }

    &.mob {
      position: relative;
      top: 50%;
      transform: translate(0, -50%);
      max-width: 334px;
      min-height: 492px;
      padding: 20px;
    }

    .account-new-header-popup-content {

      .account-new-header-popup-title {
        text-transform: capitalize;
        font-weight: 700;
        font-size: 18px;
        line-height: 24px;
        color: #1d4045;
        letter-spacing: 0px;
        text-align: left;

        @include target-md-plus{
          font-size: 24px;
          line-height: 32px;
        }
      }

      .account-new-header-popup-desc {
        font-weight: 300;
        font-size: 14px;
        line-height: 18px;
        color: #212427;
        padding: 0 10px 10px 10px;

        @media (max-width: 767px) {
          padding: 0;
        }
      }

      .account-new-header-popup-content-body{
        max-height: 316px;
        overflow-y: scroll;

        @include target-md-plus{
          max-height: 250px;
          overflow-y: scroll;
        }

        &.scroller {
          scrollbar-color: #1d4045 transparent;
          scrollbar-width: thin;
          overflow-y: scroll !important;
        }

        &::-webkit-scrollbar {
          width: 3px;
          background: transparent;
        }

        &::-webkit-scrollbar-thumb {
          background-color: #1d4045;
          border-radius: 10px;
          border: 3px solid #1d4045;
        }

        .subscription-simple-card {
          position: relative;
          &.left{
            padding-right: 10px;
            padding-left: 0px;
          }

          &.right{
            padding-left: 10px;
            padding-right: 0px;
          }

          &.no-coffee{
            @include target-md-plus{
              height: 130px;
            }
          }

          &-content{
            border-radius: 8px;
            border: 2px solid #DEDEDF;
            &.is_picked{
              border: 2px solid #228574;
            }
            &.is-paused{
              &::before{
                content: "";
                width: 100%;
                height: 100%;
                border-radius: 8px;
                background-color: #DEDEDF;
                position: absolute;
                left: 0;
                top: 0;
              }

              &.left{
                &::before{
                  @include target-md-plus{
                    width: calc(100% - 10px);
                    left: 0px;
                  }
                }
              }

              &.right{
                &::before{
                  @include target-md-plus{
                    width: calc(100% - 10px);
                    left: 10px;
                  }
                }
              }
            }
          }
          &-details{
            padding: 16px;
            @include target-md{
              height: 172px;
            }
            @include target-lg-plus{
              padding: 20px;
              height: 162px;
            }
            &.no-coffee{
              @include target-md{
                height: 88px;
              }
              @include target-lg-plus{
                height: 72px;
              }
            }
            p{
              letter-spacing: 0px;
            }
            &-name{
              color: #212427;
              /* SM-B */
              font-family: 'Apercu';
              font-size: 18px;
              font-style: normal;
              font-weight: 700;
              line-height: 24px; /* 133.333% */
              margin-bottom: 8px;
              letter-spacing: 0px;
            }
            .paused-banner{
              border-radius: 2px;
              background-color: #D3D3D4;
              padding: 0px 8px;
              height: 24px;
              width: fit-content;
              margin-bottom: 4px;
              p{
                color: #212427;
                /* XS-M */
                font-family: 'Apercu-medium';
                font-size: 16px;
                font-style: normal;
                font-weight: 500;
                line-height: 16px; /* 150% */
                letter-spacing: 0px;
              }
            }
            .being-prepared-banner{
              border-radius: 2px;
              background-color: #EDEDEE;
              padding: 0px 8px;
              height: 24px;
              width: fit-content;
              margin-bottom: 4px;
              @media(max-width: 991px){
                height: 40px;
              }

              p{
                color: #646668;
                /* XS-M */
                font-family: 'Apercu-medium';
                font-size: 16px;
                font-style: normal;
                font-weight: 500;
                line-height: 16px; /* 150% */
                letter-spacing: 0px;
                @media(max-width: 991px){
                  text-align: center;
                }
              }
            }
            .price {
              color: #212427;
              /* SM-B */
              font-family: 'Apercu';
              font-size: 18px;
              font-style: normal;
              font-weight: 700;
              line-height: 24px; /* 133.333% */
              letter-spacing: 0px;
            }
            .original-price {
              color: #212427;
              /* SM-L */
              font-family: 'Apercu';
              font-size: 14px;
              font-style: normal;
              font-weight: 300;
              line-height: 14px;
              .price-trace {
                text-decoration: line-through #212427;
                -webkit-text-decoration: line-through #212427;
                -webkit-text-decoration-line: line-through #212427;
              }
            }
            &-dispatch-date{
              color: #646668;
              /* MD-L */
              font-family: 'Apercu';
              font-size: 16px;
              font-style: normal;
              font-weight: 300;
              line-height: 22px; /* 137.5% */
              margin-bottom: 8px;
            }
            &-coffee-name{
              color: #646668;
              /* XS-M */
              font-family: 'Apercu-medium';
              font-size: 16px;
              font-style: normal;
              font-weight: 500;
              line-height: 24px; /* 150% */
              margin-bottom: 8px;
            }
            &-description{
              color: #646668;
              /* MD-L */
              font-family: 'Apercu';
              font-size: 16px;
              font-style: normal;
              font-weight: 300;
              line-height: 22px; /* 137.5% */
              margin-bottom: 0px;
              span{
                position: relative;
                padding: 0px 6px;
                &::before{
                  content: '';
                  background-color: #646668;
                  height: 3px;
                  width: 3px;
                  position: absolute;
                  top: 50%;
                  left: 3px;
                  border-radius: 50%;
                }
              }
            }
          }
          &-address{
            background-color: #F4F4F4;
            border-radius: 0px 0px 8px 8px;
            padding: 12px 16px;
            @include target-md-plus{
              padding: 16px 0px 16px 20px;
            }

            &-icon{
              position: absolute;
              top: 50%;
              transform: translateY(-50%);
            }

            p{
              color: #646668;
              padding-left: 8px;
              /* MD-L */
              font-family: 'Apercu';
              font-size: 16px;
              font-style: normal;
              font-weight: 300;
              line-height: 22px; /* 137.5% */
              letter-spacing: 0px;
              display: flex;
              span{
                overflow: hidden;
                text-overflow: ellipsis;
                display: -webkit-box;
                -webkit-line-clamp: 1; /* number of lines to show */
                line-clamp: 1;
                -webkit-box-orient: vertical;
              }
            }
          }
          &-cancel-btn{
            background-color: #e9e9e9;
            color: #212427;
          }
        }
      }
    }
  }
</style>